<template>
  <div style="font-size: 0.9rem;margin-left: 20px;margin-right: 30px;">
    <el-row style="border-bottom: 1px solid rgba(41, 155, 255, .2);padding: 35px 0 0 0;">
      <ul class="row-ul">
        <li class="row-li">
          <div class="d-inline-block" style="width: 80px;">历史范围：</div>
          <el-date-picker
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            size="mini"
            start-placeholder="开始日期"
            style="width:230px"
            type="daterange"
            v-model="screenDate"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </li>
      </ul>
      <ul class="row-ul">
        <li class="row-li">
          <div class="d-inline-block" style="width: 80px;">操作类型：</div>
          <el-select
            placeholder="请选择"
            size="mini"
            style="padding-bottom: 5px;width: 230px;"
            v-model="form.type">
            <el-option
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-for="item in options">
            </el-option>
          </el-select>
        </li>
      </ul>
      <ul class="row-ul">
        <li class="row-li">
          <div class="d-inline-block" style="width: 80px;">操作人：</div>
          <el-input placeholder="" size="mini" style="width: 230px;" v-model="form.operatorName"></el-input>
        </li>
      </ul>
      <ul class="row-ul" style="float: right!important;padding-bottom: 10px;">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="float: right">
          <el-button size="mini" :loading="isSelect"
                     style="float:right;font-weight:bold;padding:9px 25px;color:rgba(7, 230, 248, 1);"
                     @touchstart.native="filtrateForm"
                     @click.native="filtrateForm">查询
          </el-button>
        </el-col>
      </ul>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-button size="mini" class="button" style="float: right; margin-bottom: 10px;height: 30px;"
            @touchstart.native="exportExcel"    @click.native="exportExcel" :loading="isDownload">
        <img src="@/assets/images/icon/excel.png" style="margin-bottom: 4px;">
        <span style="margin-left: 5px;color: #299FFB">导出</span>
      </el-button>
      <el-table
        :data="tableData"
        height="55vh"
        border
        style="width: 100%">
        <el-table-column
          label="操作人"
          prop="operatorName">
        </el-table-column>
        <el-table-column
          label="操作人账号"
          prop="operatorAccount">
        </el-table-column>
        <el-table-column
          label="类型"
          prop="type">
        </el-table-column>
        <el-table-column
          label="描述"
          prop="description">
        </el-table-column>
        <el-table-column
          label="浏览器类型"
          prop="browser">
        </el-table-column>
        <el-table-column
          label="操作系统"
          prop="osType">
        </el-table-column>
        <el-table-column
          label="请求IP"
          prop="requestIp">
        </el-table-column>
        <el-table-column
          label="操作时间"
          prop="createTime">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="margin-top: 15px;text-align: center;" v-if="dateTotal>10">
      <el-pagination
        :total="dateTotal"
        :page-size="form.pageSize"
        :current-page.sync="form.pageCurrent"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import {userOperationLog, logInfoPage} from '@/network/ext-log';
//import {downloadBlobFile} from '@/constant/export-file';

export default {
  name: "UserOperationLog",
  data() {
    return {
      isSelect: false,
      isDownload: false,
      form: {
        pageCurrent: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: '',
        operatorName: '',
        neOperatorType: '控制设备',
      },
      options: [{
        value: '登录',
        label: '登录'
      }, {
        value: '查看',
        label: '查看'
      }, {
        value: '创建',
        label: '创建'
      }, {
        value: '更新',
        label: '更新'
      }, {
        value: '删除',
        label: '删除'
      }],
      dateTotal: 0,
      screenDate: '',
      tableData: []
    }
  },
  created() {
    this.getData(this.form);
  },
  methods: {
    // excel导出
    exportExcel() {
      this.isDownload = true;
      let exportForm = this.form;
      exportForm.pageCurrent = 1;
      exportForm.pageSize = 10000;
      this.$message.info('文件生成中，稍后请前往下载列表中下载文件!')
      userOperationLog(exportForm).then(res => {
        this.isDownload = false;
        if (res) {
          /*downloadBlobFile(res, "系统操作日志");*/
        }
      });
    },
    // 获取数据
    getData(params) {
      this.isSelect = true;
      logInfoPage(params).then(res => {
        if (res.code === 0) {
          console.log(res);
          // 列表数据
          let bln = res.data == null;
          this.tableData = bln ? null : res.data.records;
          // 总数
          this.dateTotal = bln ? 0 : res.data.total;
          // 每页数
          console.log(this.form.pageSize);
          this.form.pageSize = bln ? 10 : res.data.size;
          console.log(this.form.pageSize);
          this.form.pageCurrent = bln ? 1 : res.data.current;
        }
        this.isSelect = false;
      })
    },
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.form.pageCurrent = val;
      this.form.pageSize = 10;
      this.getData(this.form);
    },
    filtrateForm() {
      // 组装表单
      this.form.pageCurrent = 1;
      this.form.pageSize = 10;
      if (this.screenDate != null && this.screenDate.length > 0) {
        let startTime = this.screenDate[0];
        let endTime = this.screenDate[1];
        this.form.startDate = startTime;
        // 设置结束时间
        this.form.endDate = endTime;
      } else {
        this.form.startDate = '';
        // 设置结束时间
        this.form.endDate = '';
      }
      this.getData(this.form);
    }
  }
}
</script>

<style scoped>
.row-li {
  line-height: 20px;
  list-style: none;
  padding: 0;
  float: left !important;
  margin-right: 20px;
}

.row-ul {
  list-style: none;
  padding: 0;
  margin-bottom: -5px;
  float: left !important;
}
</style>
